import { useState } from 'react';
import Button from '@rio-cloud/rio-uikit/Button';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

import DataTabsSettingsDialogComponent, { VehicleStatusDataSectionKey } from './DataTabsSettingsDialogComponent';
import { DataTabsSettingsTooltip } from './DataTabsSettingsTooltip';

type DataTabsSettingsDialogContainerProps = {
    savedDataTabSettings: VehicleStatusDataSectionKey[];
    onSaveDataTabSettingsDialog: (sections: VehicleStatusDataSectionKey[]) => void;
};

const DataTabsSettingsDialogContainer = ({
    savedDataTabSettings,
    onSaveDataTabSettingsDialog,
}: DataTabsSettingsDialogContainerProps) => {
    const [isToShowDialog, setIsToShowDialog] = useState(false);

    return (
        <div className="display-flex flex-column">
            {!isToShowDialog && (
                <OverlayTrigger placement={Tooltip.BOTTOM_START} overlay={<DataTabsSettingsTooltip />}>
                    <Button
                        iconOnly
                        className="btn btn-default margin-top-auto"
                        onClick={() => {
                            setIsToShowDialog(true);
                        }}
                        aria-label="Data tabs settings"
                    >
                        <span className="uikit-icon icon-settings" role="img" aria-label="Settings icon" />
                    </Button>
                </OverlayTrigger>
            )}
            {isToShowDialog && (
                <DataTabsSettingsDialogComponent
                    isToShowDialog={isToShowDialog}
                    onClickCloseDialog={() => setIsToShowDialog(false)}
                    onClickSaveDialog={onSaveDataTabSettingsDialog}
                    savedDataTabSettings={savedDataTabSettings}
                />
            )}
        </div>
    );
};

export default DataTabsSettingsDialogContainer;
